const TermsOfService = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <div className="prose max-w-none">
        <p>Last updated: [Current Date]</p>
        
        <h2>1. Terms</h2>
        <p>By accessing Basket, you agree to be bound by these terms of service and comply with all applicable laws and regulations.</p>

        <h2>2. Use License</h2>
        <p>Permission is granted to temporarily use Basket for personal, non-commercial study purposes only.</p>

        <h2>3. Disclaimer</h2>
        <p>The materials on Basket are provided on an 'as is' basis.</p>

        {/* Add more sections as needed */}
      </div>
    </div>
  );
};

export default TermsOfService; 